import { useContext, ReactNode } from 'react';
import AppContext from '../../AppContext';
import styles from './PreviewHighlight.module.css';

const HIGHLIGHT_STATUSES = ['DRAFT', 'APPROVED', 'RELEASED'];

interface PreviewHighlightProps {
  status?: string;
  children: ReactNode;
}

export default function PreviewHighlight({ status, children }: PreviewHighlightProps) {
  const { viewMode } = useContext(AppContext);
  const shouldHighlight = viewMode === 'preview' && status && HIGHLIGHT_STATUSES.includes(status);

  if (shouldHighlight) {
    return <div className={styles.highlight}>{children}</div>;
  }

  return <>{children}</>;
}
